"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AmbientLight = void 0;
const AbstractLight_1 = require("../AbstractLight");
const ILight_1 = require("../../interface/ILight");
class AmbientLight extends AbstractLight_1.AbstractLight {
    // #region Constructors (1)
    constructor(properties) {
        super({
            color: properties.color || '#ffffff',
            intensity: properties.intensity !== undefined ? properties.intensity : 1,
            type: ILight_1.LIGHT_TYPE.AMBIENT,
            name: properties.name,
            order: properties.order,
            id: properties.id,
            version: properties.version
        });
    }
    // #endregion Constructors (1)
    // #region Public Methods (1)
    clone() {
        return new AmbientLight({
            color: this.color || '#ffffff',
            intensity: this.intensity || 0.5,
            name: this.name,
            order: this.order,
            id: this.id,
            version: this.version
        });
    }
}
exports.AmbientLight = AmbientLight;
//# sourceMappingURL=AmbientLight.js.map